// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__1dp4r","info":"PatientInfo_info__3rYp4"};